var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0642 0C14.5483 0 14.0644 0.201282 13.699 0.565778L1.18234 13.0833C1.06901 13.1967 0.99375 13.3419 0.967059 13.499L0.0109686 19.0973C-0.0310381 19.3441 0.0490372 19.5966 0.22669 19.7738C0.372401 19.9199 0.569745 20 0.772778 20C0.815659 20 0.859416 19.9965 0.902736 19.9891L6.50144 19.0338C6.65897 19.0063 6.80468 18.9315 6.91757 18.8186L19.4347 6.30144C20.1873 5.54926 20.1873 4.32363 19.4347 3.57057L16.4303 0.56534C16.0654 0.201282 15.5801 0 15.0642 0ZM6.59858 16.9519L3.04858 13.4014L12.3338 4.11666L15.8842 7.66666L6.59858 16.9519ZM2.30515 14.8428L5.1581 17.6958L1.71793 18.2834L2.30515 14.8428ZM18.3421 5.20927L16.9769 6.57449L13.4264 3.02404L14.7916 1.65839C14.8901 1.55994 15.0052 1.5455 15.0642 1.5455C15.1246 1.5455 15.2397 1.56037 15.3377 1.65839L18.3421 4.66231C18.4926 4.81283 18.4926 5.05831 18.3421 5.20927Z",
    fill: "#34657F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.fd72e7a58d281c3dd21897db2845b0e8.svg";
export { ForwardRef as ReactComponent };